import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import HeroLink from 'components/HeroLink';
import { getLocale } from 'selectors/user';
import { trackEvent } from 'utils/tracking';
import { GuestDirectorySection } from '../types';

interface Props {
  sections: GuestDirectorySection[];
  menuSlug: string;
}

const SectionsList = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  margin-top: 20px;
`;

const GuestDirectorySectionSelection: React.FC<Props> = ({ sections, menuSlug }) => {
  const currentLocale = useSelector(getLocale);

  return (
    <SectionsList className="container">
      {sections.map(section => {
        const sectionName = section.translations?.[currentLocale]?.name || section.name || '';
        const imagePath = section.images?.[0]?.path || '';

        return (
          <HeroLink
            key={section.id}
            url={`/guest-directory/menu/${menuSlug}/section/${section.slug}`}
            image={imagePath}
            text={sectionName}
            onClick={() => {
              trackEvent('select_section', {
                category: 'guest_directory',
                section_id: section.id,
                section_name: sectionName,
                menu_id: menuSlug,
              });
            }}
          />
        );
      })}
    </SectionsList>
  );
};

export default GuestDirectorySectionSelection;
